import { render, staticRenderFns } from "./DocumentPeopleShareFormFolder.vue?vue&type=template&id=51b3d841"
import script from "./DocumentPeopleShareFormFolder.vue?vue&type=script&lang=js"
export * from "./DocumentPeopleShareFormFolder.vue?vue&type=script&lang=js"
import style0 from "./DocumentPeopleShareFormFolder.vue?vue&type=style&index=0&id=51b3d841&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports